//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { NsIcon } from '@nuskin/ns-icon';

const ALERT_CONTEXT = ['error', 'info', 'notice', 'success', 'warning'];

const ALERT_TYPES = ['auto', 'banner', 'card'];

export default {
  name: 'NsAlert',
  components: {
    NsIcon,
  },
  props: {
    context: {
      type: String,
      default: 'info',
      validator(value) {
        return ALERT_CONTEXT.includes(value);
      },
    },
    title: {
      type: String,
      default: 'Information',
    },
    threshhold: {
      type: Number,
      default: 600,
    },
    type: {
      type: String,
      default: 'banner',
      validator(value) {
        return ALERT_TYPES.includes(value);
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    alertType() {
      return this.type === 'auto'
        ? this.windowWidth < this.threshhold
          ? 'card'
          : 'banner'
        : this.type;
    },
    hasDismissListener() {
      return this.$listeners && this.$listeners.dismiss;
    },
    color() {
      switch (this.context) {
        case 'error':
          return '#C81D1D';
        case 'notice':
          return '#3783B9';
        case 'success':
          return '#5BAC85';
        case 'warning':
          return '#FD983B';
        default:
          return '#3783B9';
      }
    },
    icon() {
      switch (this.context) {
        case 'error':
          return 'icon-error-color-filled';
        case 'success':
          return 'icon-success-filled';
        case 'warning':
          return 'icon-warning-filled';
        default:
          return 'icon-info-filled';
      }
    },
    titleText() {
      if (this.title) {
        return this.title;
      } else {
        switch (this.context) {
          case 'error':
            return 'Error';
          case 'notice':
            return 'Notice';
          case 'success':
            return 'Success';
          case 'warning':
            return 'Warning';
          default:
            return 'Information';
        }
      }
    },
  },
  created() {
    window.addEventListener('resize', this.windowResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.windowResize);
  },
  methods: {
    windowResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
